<template>
    <div class="auto-reply">
        <el-tabs v-model="queryInfo.type">
            <el-tab-pane label="关键词回复" name="1">
                <!-- 搜索和添加区域 -->
                <el-form :inline="true" :model="queryInfo">
                    <el-form-item>
                        <el-input
                            placeholder="搜索关键词/规则名称"
                            suffix-icon="el-icon-search"
                            v-model="queryInfo.key"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" @click="getKeywordsList">
                            查询
                        </el-button>
                        <el-button
                            type="primary"
                            size="small"
                            @click="addAutoReply()"
                        >
                            添加回复
                        </el-button>
                    </el-form-item>
                </el-form>
                <!-- 表格展示 -->
                <el-table :data="tableData" style="width: 100%" border>
                    <el-table-column type="index" width="50" label="#" align="center"> </el-table-column>
                    <el-table-column
                        prop="keyword"
                        label="关键词"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column label="回复类型" align="center">
                        <template slot-scope="scope">
                            {{
                                scope.row.msgType === "text"
                                    ? "文本类型"
                                    : "图文类型"
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="previewDetail(scope.row)"
                                >详情</el-button
                            >
                            <el-button
                                type="text"
                                @click="addAutoReply(scope.row.id)"
                                >修改</el-button
                            >
                            <!-- <el-button
                                type="text"
                                @click="deleteAutoReply(scope.row.id)"
                                >删除</el-button
                            > -->
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 回复列表分页器 -->
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    :total="totalCount"
                    @current-change="pageChange"
                    :page-size="queryInfo.limit"
                    :current-page="queryInfo.page"
                >
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="收到消息回复" name="0">
                <rich-text-editor type="0" />
            </el-tab-pane>
            <el-tab-pane label="被关注回复" name="2"
                ><rich-text-editor type="2"
            /></el-tab-pane>
        </el-tabs>
        <!-- 添加或修改对话框 -->
        <reply-add-or-update
            ref="autoReplyRef"
            @succeedAction="getKeywordsList()"
        />
        <!-- 查看回复详情对话框 -->
        <detail-reply ref="detailRef" />
    </div>
</template>

<script>
import RichTextEditor from "@/views/modules/config/child-components/rich-text-editor";
import ReplyAddOrUpdate from "@/views/modules/config/child-components/reply-add-or-update.vue";
import DetailReply from "@/views/modules/config/child-components/detail-reply.vue";
export default {
    components: {
        RichTextEditor,
        ReplyAddOrUpdate,
        DetailReply,
    },
    data() {
        return {
            // 关键词回复搜索参数
            queryInfo: {
                key: "",
                limit: 10,
                page: 1,
                type: "1",
            },
            tableData: [],
            // 总的列表数
            totalCount: 0,
        };
    },
    created() {
        this.getKeywordsList();
    },
    methods: {
        // 获取关键词回复列表数据
        getKeywordsList() {
            this.$ajaxGet("/wxMsg/list/open", this.queryInfo).then(
                ({ data }) => {
                    if (data.code === 0) {
                        this.tableData = data.data.list;
                        this.totalCount = data.data.totalCount;
                    }
                }
            );
        },
        // 添加/修改关键词回复
        addAutoReply(id) {
            this.$nextTick(() => {
                this.$refs.autoReplyRef.init(id);
            });
        },
        // 删除关键词回复
        deleteAutoReply(id) {
            const ids = [id];
            this.$confirm("确定要删除该回复吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$ajaxPost("/wxMsg/delete/open", ids).then(
                        ({ data }) => {
                            if (data.code === 0) {
                                this.getKeywordsList();
                                this.$message.success("删除成功");
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除操作",
                    });
                });
        },
        // 分页器页数改变触发事件
        pageChange(val) {
            this.queryInfo.page = val;
            this.getKeywordsList();
        },
        // 查看回复详情
        previewDetail(item) {
            this.$nextTick(() => {
                this.$refs.detailRef.init(item);
            });
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs__header .el-tabs__item.is-active {
    // background-color: #fff;
    background: #e5f9fd;
}
</style>